module.exports = __webpack_public_path__ + "img/level.34e84e21.png";